// removed by extract-text-webpack-plugin
module.exports = {"container":"container__1eBAT","thumbnail":"thumbnail__-S3y0","data":"data__3N9IQ","name":"name__1sEZP","info":"info__1T9iI","includeList":"includeList__2hlRb","includeItem":"includeItem__C1_sD","premiumBadge":"premiumBadge__3-DWI","youAreTheChosenOne":"youAreTheChosenOne__3fl1W"};


//////////////////
// WEBPACK FOOTER
// ./components/signup-flow/selected-club.sass
// module id = foLG
// module chunks = 1